import styled from "styled-components";
import chevronDown from './../../assets/pages/Search/chevronDown.svg';

export const FormContainer = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    position: relative;
    overflow: visible;
    margin-bottom: 20px;
    padding-top: 20px;

    > p {
        font-size: 12px;
        margin-top: 32px;
        width: 100%;
        margin-bottom: 8px;
        color: ${props => props.theme.palette.greyscale.grey700};
        .error-text {
            color: ${props => props.theme.palette.secondary.orange500};
            font-size: 10px;
            font-weight: 600;
        }
    }

    select {
        background: transparent;
        padding-left: 12px;
        font-size: 11px;
        font-weight: 500;
        height: 35px;
        border: 0;
        border-bottom: 1px solid ${props => props.theme.palette.greyscale.grey200};
        color: ${props => props.theme.palette.greyscale.grey700};
        -moz-appearance: none;
        -webkit-appearance: none;
        appearance: none;
        background-image: url(${chevronDown});
        background-repeat: no-repeat, repeat;
        background-position: right .7em top 50%, 0 0;
        background-size: .95em auto, 100%;
        &:focus {
            outline: none;
            border-bottom-color: ${props => props.theme.palette.primary.blue500};
        }
    }

    .schedule-select__control {
        border: 0 !important;
        border-bottom: 1px solid ${props => props.theme.palette.greyscale.grey200} !important;
        border-radius: 0 !important;
        background: transparent !important;
        min-height: 48px !important;
        cursor: pointer !important;
        
        &:hover {
            border-bottom-color: ${props => props.theme.palette.greyscale.grey300} !important;
        }
    }
    
    .schedule-select__control--is-focused {
        border: 0 !important;
        border-bottom: 1px solid ${props => props.theme.palette.primary.blue500} !important;
        border-radius: 0 !important;
        background: transparent !important;
        box-shadow: none !important;
    }
    
    .schedule-select__control--is-disabled {
        background: ${props => props.theme.palette.greyscale.grey100} !important;
        opacity: 0.6;
        cursor: not-allowed !important;
    }
    
    .schedule-select__indicator-separator {
        display: none !important;
    }
    
    .schedule-select__dropdown-indicator {
        color: ${props => props.theme.palette.greyscale.grey500} !important;
        
        &:hover {
            color: ${props => props.theme.palette.greyscale.grey700} !important;
        }
    }
    
    .schedule-select__menu {
        z-index: 9999 !important;
        border-radius: 4px !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    }
    
    .schedule-select__menu-portal {
        z-index: 9999 !important;
    }
    
    .schedule-select__option {
        cursor: pointer !important;
        padding: 12px 16px !important;
        
        &:active {
            background-color: ${props => props.theme.palette.primary.blue100} !important;
        }
    }
    
    .schedule-select__option--is-focused {
        background-color: ${props => props.theme.palette.primary.blue50} !important;
    }
    
    .schedule-select__option--is-selected {
        background-color: ${props => props.theme.palette.primary.blue500} !important;
        color: white !important;
    }

    .custom-select,
    select,
    .agendamento-button,
    .loading-state,
    .conflict-alert,
    .error-alert,
    > label {
        width: 80%;
        max-width: 100%;
    }

    .custom-select {
        margin-bottom: 16px;
    }
    
    select {
        width: 80% !important;
    }
    
    .agendamento-button {
        font-size: 12px;
        font-weight: 600;
        color: #FFF;
        border: 0;
        padding: 12px 0;
        background: ${props => props.theme.palette.primary.blue500};
        border-radius: 8px;
        cursor: pointer;
        box-sizing: border-box;
        min-height: 48px;
        transition: all 0.3s ease;
        position: relative;
        z-index: 1000;
        margin-top: 20px;
        touch-action: manipulation;
        -webkit-tap-highlight-color: transparent;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        
        &:hover {
            background: ${props => props.theme.palette.primary.blue600};
        }
        
        &:active {
            transform: scale(0.98);
            background: ${props => props.theme.palette.primary.blue700};
        }
        
        &.error-button {
            background: ${props => props.theme.palette.secondary.orange500};
            
            &:hover {
                background: ${props => props.theme.palette.secondary.orange600};
            }
            
            &:active {
                background: ${props => props.theme.palette.secondary.orange700};
            }
        }
        
        &.disabled-button {
            background: ${props => props.theme.palette.greyscale.grey500};
            cursor: not-allowed;
            opacity: 0.6;
            
            &:hover,
            &:active {
                background: ${props => props.theme.palette.greyscale.grey500};
                transform: none;
            }
        }
    }
    
    .loading-state {
        font-size: 12px;
        font-weight: 600;
        color: #FFF;
        border: 0;
        padding: 12px 0;
        background: ${props => props.theme.palette.primary.blue400};
        border-radius: 8px;
        cursor: not-allowed;
        box-sizing: border-box;
        min-height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0.8;
        margin-top: 20px;
    }
    
    > label {
        text-align: center;
        font-size: 12px;
        font-weight: 600;
        color: ${props => props.theme.palette.primary.blue500};
        border: 2px solid ${props => props.theme.palette.primary.blue500};
        padding: 8px 0;
        background: #FFF;
    }
    
    .conflict-alert {
        padding: 12px;
        background-color: #fff3cd;
        border: 1px solid #ffeaa7;
        border-radius: 6px;
        margin-bottom: 20px;
        color: #856404;
        font-size: 14px;
        box-sizing: border-box;
        
        strong {
            display: block;
            margin-bottom: 4px;
        }
        
        p {
            margin: 8px 0 0 0;
            font-size: 13px;
            line-height: 1.4;
            
            &:last-child {
                margin-top: 8px;
                font-size: 12px;
                opacity: 0.9;
            }
        }
        
        em {
            font-style: italic;
            font-size: 12px;
        }
    }
    
    .error-alert {
        padding: 10px;
        background-color: #f8d7da;
        border: 1px solid #f5c6cb;
        border-radius: 4px;
        margin-bottom: 15px;
        color: #721c24;
        box-sizing: border-box;
        font-size: 13px;
    }

    @media (min-width: ${props => props.theme.breakpoints.tablet}) and (max-width: ${props => props.theme.breakpoints.tabletLg}) {
        .custom-select,
        select,
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert,
        > label {
            width: 95%;
        }
        
        select {
            width: 95% !important;
        }
        
        .conflict-alert {
            font-size: 13px;
            
            p {
                font-size: 12px;
            }
        }
    }

    @media (min-width: ${props => props.theme.breakpoints.tabletLg}) and (max-width: ${props => props.theme.breakpoints.desktop}) {
        .custom-select,
        select,
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert,
        > label {
            width: 85%;
        }
        
        select {
            width: 85% !important;
        }
        
        .conflict-alert {
            font-size: 13px;
            
            p {
                font-size: 12px;
            }
        }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        .custom-select,
        select,
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert,
        > label {
            width: 82%;
        }
        
        select {
            width: 82% !important;
        }
        
        .conflict-alert {
            font-size: 13px;
            
            p {
                font-size: 12px;
            }
        }
    }

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        margin: 0 auto;
        padding: 16px;
        padding-top: 20px;
        box-sizing: border-box;
        position: static !important;
        overflow: visible !important;
        transform: none !important;
        
        > p {
            font-size: 13px;
            width: 100%;
            
            .error-text {
                font-size: 13px;
            }
        }
        
        .custom-select,
        select,
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert,
        > label {
            width: 100% !important;
        }
        
        select {
            width: 100% !important;
        }
        
        .schedule-select__control {
            min-height: 52px !important;
            touch-action: manipulation !important;
        }
        
        .schedule-select__menu {
            max-height: 60vh !important;
        }
        
        .schedule-select__option {
            padding: 16px !important;
            font-size: 14px !important;
        }
        
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert {
            font-size: 16px;
            min-height: 52px;
            margin-top: 20px;
            position: relative !important;
            z-index: 9999 !important;
        }
        
        .conflict-alert,
        .error-alert {
            min-height: auto;
            font-size: 14px;
            padding: 14px;
            margin-top: 0;
            margin-bottom: 16px;
            
            p {
                font-size: 13px;
            }
        }
        
        > label {
            font-size: 12px;
        }
        
        > p {
            text-align: left;
        }
    }

    @media (max-width: ${props => props.theme.breakpoints.mobileXs}) {
        padding: 12px;
        padding-top: 16px;
        
        > p {
            font-size: 12px;
            margin-top: 24px;
        }
        
        .agendamento-button,
        .loading-state {
            font-size: 14px;
            min-height: 48px;
        }
        
        .conflict-alert,
        .error-alert {
            font-size: 13px;
            padding: 12px;
            
            p {
                font-size: 12px;
            }
        }
    }

    @media (min-width: ${props => props.theme.breakpoints.desktopXl}) {
        > p {
            font-size: 14px;
            
            .error-text {
                font-size: 12px;
            }
        }
        
        .custom-select,
        select,
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert,
        > label {
            width: 82%;
        }
        
        select {
            width: 82% !important;
        }
        
        .agendamento-button,
        .loading-state,
        .conflict-alert,
        .error-alert {
            font-size: 14px;
            min-height: 48px;
        }
        
        .conflict-alert {
            font-size: 13px;
            
            p {
                font-size: 12px;
            }
        }
        
        > label {
            font-size: 14px;
        }
    }
    
    @media (min-width: ${props => props.theme.breakpoints.desktopTxl}) {
        > p {
            font-size: 15px;
        }
        
        .agendamento-button,
        .loading-state {
            font-size: 15px;
            min-height: 50px;
        }
        
        .conflict-alert {
            font-size: 14px;
            
            p {
                font-size: 13px;
            }
        }
    }
    
    * {
        max-width: 100%;
        box-sizing: border-box;
    }
`;

export const CheckBoxContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin: 24px 0;
    width: 80%;
    max-width: 100%;
    background: ${props => props.theme.palette.greyscale.grey50};
    padding: 18px 24px 18px 8px;
    cursor: pointer;
    box-sizing: border-box;
    border-radius: 4px;
    transition: background-color 0.2s ease;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    
    &:hover {
        background: ${props => props.theme.palette.greyscale.grey100};
    }
    
    > input[type="checkbox"] {
        min-width: 18px;
        min-height: 18px;
        cursor: pointer;
        accent-color: ${props => props.theme.palette.primary.blue500};
        flex-shrink: 0;
    }
    
    > label {
        font-size: 12px;
        margin-left: 8px;
        cursor: pointer;
        width: auto;
        background: none;
        border: none;
        color: ${props => props.theme.palette.greyscale.grey800};
        padding: 0;
        text-align: left;
        word-wrap: break-word;
        overflow-wrap: break-word;
        flex: 1;
        line-height: 1.4;
    }

    @media (min-width: ${props => props.theme.breakpoints.tablet}) and (max-width: ${props => props.theme.breakpoints.tabletLg}) {
        width: 95%;
        padding: 18px 16px 18px 8px;
        
        > label {
            font-size: 12px;
            white-space: normal;
            word-break: keep-all;
        }
    }
    
    @media (min-width: ${props => props.theme.breakpoints.tabletLg}) and (max-width: ${props => props.theme.breakpoints.desktop}) {
        width: 85%;
        padding: 18px 16px 18px 8px;
        
        > label {
            font-size: 14px;
            white-space: normal;
        }
    }
    
    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
        width: 82%;
        
        > label {
            font-size: 14px;
            white-space: nowrap;
        }
    }

    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
        width: 100%;
        padding: 16px 16px 16px 8px;
        
        > label {
            font-size: 14px;
            white-space: normal;
        }
    }
    
    @media (max-width: ${props => props.theme.breakpoints.mobileXs}) {
        padding: 12px;
        margin: 16px 0;
        
        > label {
            font-size: 12px;
        }
    }
`;

export const SpaceToFooter = styled.div`
    flex: 1;
`;